import { defineAction } from './types';

export default defineAction({
  action: 'DATA_UPLOAD_FROM_MEETING',
  getHref: attrs =>
    `/client/${attrs.client_id}/detected-entities?fileId=${attrs.data_upload_file_id}&fileName=${encodeURIComponent(attrs.event_title)}&originMeetingId=${attrs.event_id}`,
  getFollowUp: () => ({
    title: 'Review extracted meeting data',
    message:
      'Your meeting transcription has been processed. Review the extracted data and confirm what should be saved to the client record.',
  }),
  completionEvents: ['FILE_PROCESSED'],
});
